import { flattenObject } from '../helpers/genericFormator';
import { deepClone } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_EXPENSE': {
      let { expenses = {} } = state;
      const { filterQuery = {} } = action;
      if (!expenses?.[action?.key]) {
        expenses[action?.key] = [];
      }
      const { data = [], count } = action?.data || {};
      const dt = [];

      data.forEach(element => {
        dt.push(flattenObject(deepClone(element)));
      });

      expenses[action?.key] = { data: dt, count } || [];
      return {
        ...state,
        expenses: expenses,
        filterQuery,
      };
    }
    case 'SET_SINGLE_TXN_DATA': {
      return {
        ...state,
        TxnDispute: action?.data?.transaction?.dispute || {},
      };
    }
    case 'SET_SEARCH_FIELDS': {
      return {
        ...state,
        searchFields: action.data,
      };
    }
    case 'SET_DISPUTE_REASON': {
      return {
        ...state,
        disputeReason: action.data,
      };
    }
    case 'CLEAREXPENSE': {
      // Not clearing the filterquery on unmount, since its required when page is viewed back
      return {
        filterQuery: state.filterQuery || {}
      };
    }
    case 'CLEAR_EXPENSE_FILTER_QUERY': {
      return {
        ...state,
        filterQuery: {}
      };
    }
    case 'SEARCH': {
      return {
        ...state,
        expenses: {},
      };
    }
    case 'SET_COLUMN': {
      return {
        ...state,
        savedColumn: action.column,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
